import React, { Fragment } from 'react'

const ProfileHEader = () => {
    return (
        <Fragment>
            <div className="container-fluid dasshboard QR">
                <div className="row">
                    <div className="col-sm-12">
                        <p>My Profile</p>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default ProfileHEader
